import type { SVGProps } from 'react';

export function TestTubeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.293 4.293a1 1 0 0 1 1.414 0l5 5 .068.075a1 1 0 0 1-1.245 1.515L7.535 21.88a3.829 3.829 0 0 1-5.414-5.415L13.116 5.469a1 1 0 0 1 .177-1.176m-2.88 6.708h5.172l1.5-1.501L14.5 6.914zM20.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M17 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2M20 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
    </svg>
  );
}
